export const STORAGE_KEY = 'hlc_stick_fit_picks';
const MAX_AGE_MS = 30 * 60 * 1000;

export function buildGloboParams({ curves, hand, purchaseFlex, standardLen, tier }) {
  return {
    Curve: curves[0],
    Flex: String(purchaseFlex),
    Graphics: 'Standard',
    Kickpoint: purchaseFlex >= 90 ? 'High' : purchaseFlex >= 75 ? 'Mid' : 'Low',
    Length: String(standardLen),
    Side: hand === 'left' ? 'Left' : 'Right',
    Size: tier.charAt(0).toUpperCase() + tier.slice(1),
  };
}

export function storeStickFitResults(params) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify({
    data: params,
    timestamp: Date.now(),
  }));
}

export function getStoredStickFitResults() {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    const { data, timestamp } = JSON.parse(raw);
    if (Date.now() - timestamp > MAX_AGE_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return data;
  } catch {
    localStorage.removeItem(STORAGE_KEY);
    return null;
  }
}

export function clearStoredStickFitResults() {
  localStorage.removeItem(STORAGE_KEY);
}

export function appendProductParam(url, tier) {
  const parsed = new URL(url, 'http://localhost');
  parsed.searchParams.set('product', tier);
  if (url.startsWith('http')) return parsed.href;
  return parsed.pathname + parsed.search;
}

export function matchesValue(inputValue, targetValue) {
  const a = inputValue.toLowerCase();
  const b = targetValue.toLowerCase();
  return a === b || a.startsWith(b + ' ') || a.startsWith(b + '-');
}

export function selectGloboOption(name, value) {
  const nameLower = name.toLowerCase().replace(/[^a-z0-9]/g, '');
  const labels = document.querySelectorAll(
    'label, legend, .globo-option-label, [data-option-label]',
  );

  for (const label of labels) {
    const labelText = label.textContent.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
    if (!labelText.includes(nameLower)) continue;

    const wrapper =
      label.closest(
        '.globo-option, .globo-product-option, [data-option-index], fieldset',
      ) || label.parentElement;
    if (!wrapper) continue;

    const inputs = wrapper.querySelectorAll('input[type="radio"], input[type="checkbox"]');
    for (const input of inputs) {
      if (matchesValue(input.value, value)) {
        input.checked = true;
        input.click();
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }

    const select = wrapper.querySelector('select');
    if (select) {
      for (const option of select.options) {
        if (matchesValue(option.value, value)) {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }
    }

    break;
  }
  return false;
}

function applyStickFitResults() {
  const results = getStoredStickFitResults();
  if (!results) return false;

  let applied = false;
  for (const [name, value] of Object.entries(results)) {
    if (selectGloboOption(name, value)) applied = true;
  }

  if (applied) {
    clearStoredStickFitResults();
  }
  return applied;
}

export function initStickFitPrefill() {
  if (!getStoredStickFitResults()) return;

  document.addEventListener('gpoRenderCompleted', () => applyStickFitResults());
  setTimeout(() => applyStickFitResults(), 5000);
}

if (typeof window !== 'undefined') {
  window.HLC = window.HLC || {};
  window.HLC.appendProductParam = appendProductParam;
  window.HLC.buildGloboParams = buildGloboParams;
  window.HLC.storeStickFitResults = storeStickFitResults;
}

if (typeof window !== 'undefined' && typeof localStorage !== 'undefined' && typeof localStorage.getItem === 'function') {
  window.addEventListener('storage', (event) => {
    if (event.key !== STORAGE_KEY || !event.newValue) return;
    document.addEventListener('gpoRenderCompleted', () => applyStickFitResults(), { once: true });
    setTimeout(() => applyStickFitResults(), 2000);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickFitPrefill);
  } else {
    initStickFitPrefill();
  }
}
